import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { tryToFetchSingleGuest } from '../../../store/brokers/partner/guests/guestsSlice';
import GuestInfoTab from './details/GuestInfoTab';
import { useGetGuestDetailsInfoMutation } from '../../../store/reservations/reservationsApi';
import Button from '../../../shared/button';
import ReservationHistory from './details/ReservationHistory';
import { LoadingMessages } from '../../../utils/constants/guest-messages';
import moment from 'moment';

const tabs = [
    { label: 'Guest Info', value: 'info' },
    { label: 'Booking History', value: 'history' },
]

const GuestDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [activeTab, setActiveTab] = useState<any>(tabs[0]);
    const [dateGuest, setDateGuest] = useState<any>();
    const [detailsData, setDetailsData] = useState<any>();
    const [loadingText, setLoadingText] = useState(LoadingMessages[0]);
    const [getGuestDetailsInfo, { isLoading }] = useGetGuestDetailsInfoMutation();
    const details = useAppSelector((state) => state?.guests?.guestDetails);

    const onGoBack = () => {
        navigate(-1)
    }

    useEffect(() => {
        if (!isLoading) {
            setLoadingText(LoadingMessages[0]);
            return;
        }
        let index = 0;
        const interval = setInterval(() => {
            index = (index + 1) % LoadingMessages.length;
            setLoadingText(LoadingMessages[index]);
        }, 5000);

        return () => clearInterval(interval);
    }, [isLoading]);

    useEffect(() => {
        if (details && id) {
            setDetailsData(details)
            setDateGuest(details?.updatedAtGuestInfo)
        }
    }, [details])

    useEffect(() => {
        if (id) {
            dispatch(tryToFetchSingleGuest(id));
        }
    }, [id]);

    const onChangeActiveTab = (tab: any) => {
        setActiveTab(tab)
    }

    const onUpdateDataForGuest = async () => {
        try {
            const guestInfoData = {
                name: `${detailsData?.firstName} ${detailsData?.lastName}`,
                refresh: true
            }
            const response: any = await getGuestDetailsInfo(guestInfoData).unwrap();
            setDetailsData((prevData: any) => ({
                ...detailsData || {},
                guests: response?.data?.guests
            }))
            setDateGuest(new Date())
        } catch (err) {
            // error here
        }
    }

    return (
        <div>
            <div className={'flex flex-row items-center justify-between'}>
                <div className='flex flex-row items-center'>
                    <div data-qa={'back-button'} onClick={onGoBack} className='md:-ml-2 xl:-ml-5 md:mr-2 xl:mr-4'>
                        <img src={'/assets/shared/go-back-new.svg'} className={'w-[35px] object-contain cursor-pointer'} />
                    </div>
                    <p className='text-primary-light text-sm font-medium'>Guests &gt; Guest Intelligence Information</p>
                </div>
            </div>
            <div className='flex flex-col md:flex-row md:justify-between my-5'>
                <div className='flex flex-row items-center'>
                    {tabs?.map((item: any, idx: number) => {
                        return (
                            <div
                                key={idx}
                                onClick={() => onChangeActiveTab(item)}
                                className={`${activeTab?.value === item?.value ? 'border-b border-b-[#00330F] pb-2' : '!pb-3'}  pt-y px-4 cursor-pointer hover:opacity-90`}>
                                <p className={`${activeTab?.value === item?.value ? 'text-primary-default' : 'text-primary-light'}`}>{item?.label}</p>
                            </div>
                        )
                    })}
                </div>
                <div>
                    {isLoading ?
                        <p className="px-2 py-2 text-primary-default">{loadingText}</p>
                        : <Button
                            label={'Run Guest Intelligence and Update Info'}
                            icon={<img src="/assets/shared/reviewt.svg" className='object-contain mr-2 w-[18px]' />}
                            className='btn-primary-rounded-less flex flex-row items-center text-sx font-medium'
                            onClickButton={onUpdateDataForGuest} />
                    }
                    <p className='text-primary-light my-2 text-right'>Last Update: {moment(dateGuest)?.format('DD/MM/YYYY')}</p>
                </div>
            </div>
            {activeTab?.value === 'info' ?
                <GuestInfoTab
                    data={detailsData}
                    id={id || ''}
                />
                : <ReservationHistory
                    id={detailsData?.userId || ''}
                />
            }
        </div>
    )
}
export default GuestDetails;